import React from "react";

export default function FirstLoginWelcome({ onDismiss }) {
  return (
    <div className="first-login-overlay" role="dialog" aria-modal="true" aria-labelledby="first-login-title">
      <div className="first-login-card">
        <h2 id="first-login-title" className="first-login-title">Welcome to the new My E-Crane</h2>
        <p className="first-login-body">
          This system is designed to work like the one you already know. Take a look around — you
          should be able to find your way.
        </p>
        <div className="first-login-actions">
          <button type="button" onClick={onDismiss}>
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
